export default __webpack_public_path__ + "static/AGaramondPro-Bold-4697942832ad3dbd309aff0916ce017c.woff";